const serverURL = "https://sounds-of-earth.herokuapp.com/api";

export default serverURL;
